export interface NavButtonConfig {
  key: string;
  label: string;
  icon: string;
  activeIcon: string;
}

export const NAV_BUTTON_CONFIG: Record<string, NavButtonConfig> = {
  HOME: {
    key: 'HOME',
    label: $localize`:@@home:Home`,
    icon: 'https://cdn.cureskin.com/app/img/rebranded_home.svg',
    activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_home_solid.svg',
  },
  FACE: {
    key: 'FACE',
    label: $localize`:@@face:Face`,
    icon: 'https://cdn.cureskin.com/app/img/rebranded_face_female.svg',
    activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_face_female_solid.svg',
  },
  HAIR: {
    key: 'HAIR',
    label: $localize`:@@hair:Hair`,
    icon: 'https://cdn.cureskin.com/app/img/rebranded_hair_female.svg',
    activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_hair_female_solid.svg',
  },
  SHOP: {
    key: 'SHOP',
    label: $localize`:@@shop:Shop`,
    icon: 'https://cdn.cureskin.com/app/img/rebranded_storefront.svg',
    activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_storefront_solid.svg',
  },
  PHOTO: {
    key: 'PHOTO',
    label: $localize`:@@photo:Photo`,
    icon: 'https://cdn.cureskin.com/app/img/rebranded_photo_camera.svg',
    activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_photo_camera.svg',
  },
  HELP: {
    key: 'HELP',
    label: $localize`:@@help:Help`,
    icon: 'https://cdn.cureskin.com/app/img/rebranded_help.svg',
    activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_help_solid.svg',
  },
  TREATMENT: {
    key: 'TREATMENT',
    label: $localize`:@@treatment: Treatment `,
    icon: 'https://cdn.cureskin.com/app/img/rebranded_sanitizer.svg',
    activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_sanitizer.svg',
  },
  EXPLORE: {
    key: 'EXPLORE',
    label: $localize`:@@explore:Explore`,
    icon: 'https://cdn.cureskin.com/app/img/rebranded_manage_search.svg',
    activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_manage_search_solid.svg',
  },
};

export const NAV_ROUTES: Record<string, { path: string[]; queryParams?: Record<string, string> }> = {
  HOME: { path: ['/user'], queryParams: { tab: 'home' } },
  FACE: { path: ['/user'], queryParams: { tab: 'regimen', class: 'FACE' } },
  HAIR: { path: ['/user'], queryParams: { tab: 'regimen', class: 'HAIR' } },
  TREATMENT: { path: ['/user'], queryParams: { tab: 'regimen' } },
  SHOP: { path: ['/user'], queryParams: { tab: 'shop' } },
  EXPLORE: { path: ['/user'], queryParams: { tab: 'explore' } },
  HELP: { path: ['/support'] },
  PHOTO: { path: ['/user/instantCheckup'] },
};

// Reverse-lookup entries derived from NAV_ROUTES, sorted by specificity (most queryParams first).
// HOME is excluded as it serves as the default fallback.
export const NAV_ROUTE_ENTRIES = Object.entries(NAV_ROUTES)
  .filter(([key]) => key !== 'HOME')
  .sort(([, a], [, b]) =>
    Object.keys(b.queryParams || {}).length - Object.keys(a.queryParams || {}).length,
  );

export const GENDER_ICONS: Record<string, Record<string, { icon: string; activeIcon: string }>> = {
  Male: {
    FACE: {
      icon: 'https://cdn.cureskin.com/app/img/rebranded_face_male.svg',
      activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_face_male_solid.svg',
    },
    HAIR: {
      icon: 'https://cdn.cureskin.com/app/img/rebranded_hair_male.svg',
      activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_hair_male_solid.svg',
    },
  },
  Female: {
    FACE: {
      icon: 'https://cdn.cureskin.com/app/img/rebranded_face_female.svg',
      activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_face_female_solid.svg',
    },
    HAIR: {
      icon: 'https://cdn.cureskin.com/app/img/rebranded_hair_female.svg',
      activeIcon: 'https://cdn.cureskin.com/app/img/rebranded_hair_female_solid.svg',
    },
  },
};
